import { Component, OnInit } from '@angular/core';
import {UserService} from '../../servies/user/user.service';
import * as $ from 'jquery';
import { Title }     from '@angular/platform-browser';
import { ActivatedRoute,Router } from '@angular/router';
import { ElementRef } from '@angular/core';
import { not } from '@angular/compiler/src/output/output_ast';
@Component({
  selector: 'app-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.css']
})


export class DefaultComponent implements OnInit {
  public user: any;
  public str_ixDemo: string;
  
  public constructor(private _userService: UserService,private router:Router,private activeRoute: ActivatedRoute) { }

  ngOnInit() {
    if(sessionStorage.getItem('loggedin')=='true'){
      this.router.navigate(['/search'])
    }
    else{
    this.user = {
      username: '',
      password: ''
    };
    this.activeRoute.queryParams.subscribe(params => {
      
      this.str_ixDemo=params['login'];
      console.log(this.str_ixDemo);

      if(this.str_ixDemo!=undefined && this.str_ixDemo!='' && this.str_ixDemo=='ixdemo')
      {
          console.log('inside if');
          this.user.username = 'ixdemo@intuceo.com';
          this.user.password = 'admin';     
          this.login();        
      }
    });
    
  }
  }
  public token: string;
  login() {                        
      this._userService.login({'username': this.user.username, 'password': this.user.password});      
  }

  refreshToken() {
    this._userService.refreshToken();
  }

  logout() {
   this._userService.logout();
  }
    
}
